<div class="section spinner" style="min-height: 50vh; margin-top: 25vh;" *ngIf="logueandoApp">

  <img src="assets/images/logo-borde-gris.svg" class="brand-shell spinner">
  <div *ngIf="errorLogin" id="userIncorrect" class="alert alert-warning p-2" role="alert"  [innerHTML]="errorLogin">

  </div>
</div>

<div *ngIf="!logueandoApp" [ngClass]="isModal?'modal-login':''">
  <div class="container">
    <div class="login-container">
      <div *ngIf="!completeProfile" class="login card">
        <button type="button" *ngIf="isModal" class="login-close" aria-label="Close" (click)="initialLogin()" (click)="closeLogin()">
          <img src="../../../../assets/images/register-asset/close.svg" alt="icon close">
        </button>

        <div class="login-header">
          <img class="login-img" src="../../../../assets/images/logo-header-shell.svg" alt="">
          <h4 *ngIf="!recuperando" class="login-title">Ingresá o registrate con tu DNI o e-mail</h4>
          <h4 *ngIf="recuperando">¿Olvidaste tu contraseña?</h4>
        </div>
        <form class="login-form" *ngIf="step === 1" [formGroup]='loginForm' (ngSubmit)='checkUserStatus(loginForm.value)'>

          <div *ngIf="!userExist" class="alert-error" role="alert">
            <div class="circle-icon">
              <img src="assets/images/circle-alert.svg" alt="icon circle alert">
            </div>
            <div>
              <p>No pudimos encontrar tu cuenta de Shell box. Creá tu cuenta o intentá nuevamente. <b (click)="registro()">Registrate aquí</b></p>
            </div>
          </div>

          <div class="mt-3 mb-3" *ngIf="!recuperado">
            <label for="user_name" class="form-label">Email o DNI</label>
            <div [ngClass]="loginForm.get('principal')?.value?.length > 0 ? 'wrap-password-user-error' : 'wrap-password-user'">
              <input (input)="deleteErrors()" [ngStyle]="{border: !userExist && '2px solid #DD1D21'}" [ngClass]="{isInvalid: inputsErros('user_name')}" type="text" class="form-control login-form-input" id="user_name"
                name="login" placeholder="Ingresá tu email o dni" formControlName="principal">
            </div>
          </div>

          <button *ngIf="!recuperando && !recuperado" id="loginModal" [disabled]="loginIn" [ngClass]="{'loading': loginIn}" class="btn btn-primary login-form-input" type="submit" (click)="checkUserStatus(loginForm.value)"> <span *ngIf="loginIn" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> <span *ngIf="!loginIn">Ingresar</span></button>      
          <input *ngIf="!recuperando && !recuperado" id="registerOption" class="btn btn-light login-form-input mt-3" type="button" (click)="registro()" value="Registrarme">
        </form>
        <form class="login-form" *ngIf="step === 2" [formGroup]='loginForm' (ngSubmit)='onLogin(loginForm.value)'>
          <div *ngIf="errorLogin" id="id_not_ok_login" class="alert alert-warning p-2" role="alert"  [innerHTML]="errorLogin">

          </div>
          <div *ngIf="errorRecoverPassword" id="id_not_ok_recover" class="alert alert-warning p-2" role="alert">
            <div>
              <p>El email ingresado no se encuentra registrado. Si no recordás tu email, podés contactarte con el Call Center para actualizarlo</p>
              <div class="contactNetworks">
                <img class="telephone" src="../../../assets/images/telephone.png" alt="mobilephonecontact">
                <a href="tel:08103338652">0810-333-8652</a><br>
              </div>
              <div class="contactNetworks">
                <img class="email" src="../../../assets/images/email.png" alt="email contact">
                <a href="mailto:shellbox@raizen.com.ar">shellbox&#64;raizen.com.ar</a>
              </div>
            </div>
          </div>
          <div *ngIf="expiredLinkError" class="alert alert-warning p-2" role="alert">
            <p>El enlace recibido por email ha caducado, debe solicitar uno nuevo.</p>
          </div>
          <div class="mt-3"  *ngIf="!recuperado">
            <label for="user_name" class="form-label">{{ recuperando || recuperado ? 'Email' : 'Email o DNI' }}</label>
            <input (input)="deleteErrors()" [ngClass]="{isInvalid: inputsErros('user_name')}" type="text" class="form-control login-form-input" id="user_name"
              name="login" [placeholder]="recuperando || recuperado ? 'Ingresá tu email' : 'Ingresá tu email o dni'" formControlName="principal"  [attr.readonly]="!recuperado && !recuperando ? true : null">
          </div>

          <div class="mt-3" *ngIf="!recuperando">
            <label for="password" class="form-label">Contraseña</label>
            <div [ngClass]="loginForm.get('password')?.value?.length > 0 ? 'wrap-password-error' : 'wrap-password'">
              <input [type]="!showpass?'password':'text'"  (input)="deleteErrors()" class="password" id="password" name="login" class="form-control login-form-input"
                placeholder="Ingresá tu contraseña" formControlName="password">
              <span class="eye" [ngClass]="showpass?'show':''" (click)="showpass = !showpass"></span>
            </div>
          </div>

          <div class="mt-3" *ngIf="recuperado" style="text-align: center;">
            Te hemos enviado un correo para continuar con el proceso de recupero de contraseña
          </div>

          <div *ngIf="!recuperado" class="forgot-pass mt-3 mb-4">
            <a *ngIf="!recuperando" (click)="recupero()" class="btn btn-link">¿Olvidaste tu contraseña?</a>
          </div>   
          <button *ngIf="!recuperando && !recuperado" id="loginModal" [disabled]="!areFieldsComplete() || loginIn" [ngClass]="loginIn?'loading':''" class="btn btn-primary login-form-input" type="submit" value="Iniciar sesión"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Iniciar Sesión</button>
          <button *ngIf="recuperando && !recuperado" [disabled]="!areRecoveryFieldsComplete() || loginIn" [ngClass]="loginIn?'loading':''" (click)="recuperarPassword()" class="btn btn-primary login-form-input" type="button" value="Recuperar contraseña"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Recuperar Contraseña</button>
          <input *ngIf="!recuperando && !recuperado" id="registerOption" class="btn btn-light login-form-input mt-3" type="button" (click)="registro()" value="Registrarme">

          <input *ngIf="recuperando" class="btn btn-light login-form-input mt-3" type="submit" (click)="noRecupero()" value="Volver">


        </form>
      </div>
      <div *ngIf="completeProfile">
        <app-complete-register [userData]="preRegisteredData" (close)="completeProfile = false"></app-complete-register>
      </div>        
    </div>
  </div>
</div>




<div class="modal-recupero">
  <div class="container">
    <div class="login-container">
      <div class="login card">

        <img class="login-img" src="../../../../assets/images/logo-header-shell.svg" alt="">
        <h4 *ngIf="!recuperando">Cambiar contraseña</h4>
        <h4 *ngIf="recuperando">¿Olvidaste tu contraseña?</h4>
        <form class="login-form" [formGroup]='recuperoForm' (ngSubmit)='onLogin(loginForm.value)'>
          <div *ngIf="errorLogin" class="alert alert-warning p-2" role="alert">
            {{errorLogin}}
          </div>
          <div *ngIf="errorRecoverPasswordMessage" class="alert alert-warning p-2" role="alert">
            {{ errorRecoverPasswordMessage }}
          </div>          
          <div class="mt-3" *ngIf="!recuperado">
            <label for="password-recupero" class="form-label">Ingresá tu nueva contraseña</label>
            <div class="wrap-password">
                <input [type]="!showpass?'password':'text'" (input)="validatePassword()" class="password" id="password-recupero" name="password-recupero" class="form-control login-form-input"
                  placeholder="Ingresá tu contraseña" formControlName="passwordRecupero">
                  <span class="eye" [ngClass]="showpass?'show':''" (click)="showpass = !showpass"></span>
            </div>
            <app-password-requirements class="mt-2" [control]="recuperoForm.get('passwordRecupero')" ></app-password-requirements>  
          </div>

          <div class="mt-3" *ngIf="!recuperado">
            <input id="register_accept_terms_recover" data-gtm-id="register_accept_terms_recover" name="register_accept_terms_recover" type="checkbox" value="1" required (change)="checkTerms()" formControlName="registerTerminosCondiciones" />
            <label for="register_accept_terms_recover" class="form-label register-light">He leído y acepto los <a href="assets/terminos-y-condiciones.pdf" target="_blank">términos y condiciones</a></label>
          </div>

          <div class="mt-3" *ngIf="recuperado" style="text-align: center;">
            Su contraseña ha sido cambiada con éxito.
          </div>

          <br>

          <button *ngIf="!recuperado" [disabled]="!recuperoForm.valid || loginIn" [ngClass]="loginIn?'loading':''" class="btn btn-primary login-form-input" type="button" (click)="recuperarPassword2()" value="Cambiar contraseña"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Cambiar contraseña</button>

          <input *ngIf="recuperado" class="btn btn-light login-form-input mt-3" id="recoverPasswordLogin" type="button" (click)="initialState()" value="Iniciar sesión">
        </form>
      </div>
    </div>
  </div>
</div>